
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useStockItems = () => {
  return useQuery({
    queryKey: ['stockItems'],
    queryFn: async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          throw new Error("Non authentifié");
        }

        // Récupérer les données du propriétaire pour trouver le type d'entreprise
        const { data: ownerData, error: ownerError } = await supabase
          .from('owner_data')
          .select('business_type_id')
          .eq('owner_id', user.id)
          .maybeSingle();

        if (ownerError) {
          throw ownerError;
        }

        if (!ownerData?.business_type_id) {
          throw new Error("Type d'entreprise non défini");
        }

        // Récupérer tous les stocks de l'entreprise
        const { data: businessStocks, error: stockError } = await supabase
          .from('business_stocks')
          .select('id')
          .eq('owner_id', user.id);

        if (stockError) {
          throw stockError;
        }

        // Si aucun stock n'existe, en créer un nouveau
        if (!businessStocks || businessStocks.length === 0) {
          const { data: newBusinessStock, error: createError } = await supabase
            .from('business_stocks')
            .insert({
              business_id: ownerData.business_type_id,
              name: 'Stock Principal',
              owner_id: user.id
            })
            .select('*')
            .single();

          if (createError) {
            throw createError;
          }

          return [];
        }

        // Récupérer les articles de tous les stocks en une seule requête
        const { data: items, error: itemsError } = await supabase
          .from('stock_items')
          .select('*')
          .in('stock_id', businessStocks.map(stock => stock.id));

        if (itemsError) {
          throw itemsError;
        }

        return items || [];
        
      } catch (error: any) {
        toast.error(error.message || "Erreur lors de la récupération du stock");
        throw error;
      }
    },
    retry: 1,
    staleTime: 1000 * 60, // Cache pendant 1 minute
    gcTime: 1000 * 60 * 5, // Garde en cache pendant 5 minutes
  });
};
